var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"center-cell"},[(_vm.props.row.comment || _vm.props.row.has_comments)?_c('message-text-icon',{staticClass:"clickable",attrs:{"title":'Order Comments',"data-id":_vm.props.row.ID || _vm.props.row.order_id,"size":17},on:{"click":_vm.handleClick}}):_c('span',[_vm._v("-")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }